export default [
  { label: 'Transação', value: 'protocol_number' },
  { label: 'Data e Hora', value: 'created_at' },
  { label: 'Estornado em', value: 'refunded_at' },
  { label: 'Tipo', value: 'eventable_type' },
  { label: 'Detalhes', value: 'details' },
  { label: 'Origem do Pagamento', value: 'from_client_balance' },
  { label: 'Vlr. Bruto', value: 'gross_value' },
  { label: 'Tarifas', value: 'fee_total_amount' },
  { label: 'Vlr. Líquido', value: 'total_amount' },
  { label: 'Ret. IR', value: 'income_tax_total' },
  { label: 'Filial', value: 'branch' },
  { label: 'Cartão', value: 'card' },
  { label: 'Placa', value: 'equipment_field_for_display_value' },
  { label: 'Consumidor', value: 'buyer' },
  { label: 'Método de captura', value: 'capture_method' },
];

